import React, { useState, useEffect } from 'react';
import Sidemenu from './components/sidemenu/Sidemenu.jsx'; // Path to your sidebar component
import Navbar from './components/navbar/Navbar.jsx';   // Path to your navbar component
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

const Layout = () => {
  // Get the sidebar state from localStorage to adjust content margin
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    return JSON.parse(localStorage.getItem('sidebarIsOpen')) ?? true;
  });

  // Listen for changes to the sidebar state in localStorage
  useEffect(() => {
    const handleStorageChange = () => {
      const isOpen = JSON.parse(localStorage.getItem('sidebarIsOpen')) ?? true;
      setSidebarOpen(isOpen);
    };

    // Check for changes every 500ms
    const interval = setInterval(handleStorageChange, 500);

    // Clean up the interval
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <Box sx={{ position: 'sticky', top: 0, zIndex: 1100, boxShadow: 'none' }}>
        <Navbar />
      </Box>
      <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
        <Sidemenu />
        <div 
          className="content" 
          style={{
            flex: 1,
            transition: 'margin-left 0.3s ease',
            padding: '20px',
            overflowY: 'auto',
            height: 'calc(100vh - 64px)', // Adjust based on navbar height
          }}
        >
          <Outlet/>
        </div>
      </div>
    </div>
  );
};

export default Layout;
